const settings = {
    title: 'S&OP Game',
    description: 'Sales en Operations Planning Game',
    apiUrl: import.meta.env.VITE_BASE_URL,
}

export default settings